import React from "react";
import line from "../assets/line.png";

const Innovation = () => {
  const steps = [
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
    "To pioneer AI-driven innovation that transforms industries, enhances decision-making, and empowers businesses with intelligent, scalable, and future-ready solutions",
  ];

  return (
<section className="">
  <div className="relative w-full h-full z-20 flex flex-col justify-center items-center min-h-screen px-4">

    {/* Heading */}
    <h2 className="text-2xl md:text-4xl font-semibold mb-6">
      <div className="relative inline-block pb-2">
        <span className="relative z-10">
          <span className="text-[#00cfff]">Our</span>{" "}
          <span className="text-black">Path to Innovation</span>
        </span>
        <img
          src={line}
          alt="underline"
          className="absolute left-0 bottom-0 h-[8px] w-full object-contain"
        />
      </div>
    </h2>

    {/* Timeline wrapper */}
    <div className="relative pl-4 md:pl-8">

      {/* Vertical line */}
      <div
        className="
          absolute 
          top-0 bottom-0 
          w-px border-l-2 border-dashed
        "
        style={{
          borderColor: "#7B61FF",
          left: "22px",    // mobile position
        }}
      />

      {/* Items */}
      <div className="flex flex-col gap-10 md:gap-6">

        {steps.map((text, index) => (
          <div 
            key={index} 
            className="flex items-start gap-4 md:gap-6"
          >

            {/* Circle */}
            <div className="relative w-12 md:w-14 flex justify-center pt-1">
              <div
                className="
                  w-10 h-10 md:w-14 md:h-14
                  rounded-full border-4 
                  border-[#7B61FF] bg-white shadow-md
                "
              />
            </div>

            {/* Text */}
           <p
  className="
    text-gray-800 font-calibri 
    text-[26px] leading-relaxed
    max-w-[100%] md:max-w-[85%]
  "
>
  {text}
</p>


          </div>
        ))}

      </div>
    </div>

  </div>
</section>




  );
};

export default Innovation;